/**
 * UX-85 — SEULE définition des entrées de menu de web-parent (route, clé i18n,
 * icône), consommée par `components/Sidebar.tsx` (dans cet ordre) et par
 * `breadcrumbs.ts` (maillons parents du fil d'Ariane) : renommer une entrée
 * renomme aussi son maillon. Clés i18n et non libellés : la traduction se fait
 * au rendu, avec la langue courante (voir src/i18n).
 */
export interface NavEntry {
  to: string;
  labelKey: string;
  icon: string;
}

export const NAV = {
  home: { to: '/', labelKey: 'sidebar.home', icon: '🏠' },
  inscriptions: { to: '/inscriptions', labelKey: 'sidebar.inscriptions', icon: '📋' },
  payments: { to: '/payments', labelKey: 'sidebar.payments', icon: '💰' },
  attendance: { to: '/attendance', labelKey: 'sidebar.attendance', icon: '🗓️' },
  // EVA-07 : même icône que l'entrée « Notes » de web-admin (mapping UX-21).
  grades: { to: '/grades', labelKey: 'sidebar.grades', icon: '📝' },
  documents: { to: '/documents', labelKey: 'sidebar.documents', icon: '📄' },
  settings: { to: '/settings', labelKey: 'sidebar.settings', icon: '⚙️' },
} as const satisfies Record<string, NavEntry>;

/** Liens de la Sidebar après « Accueil », dans l'ordre de la référence Claude Design. */
export const MAIN_NAV: readonly NavEntry[] = [NAV.inscriptions, NAV.payments, NAV.attendance, NAV.grades, NAV.documents, NAV.settings];
